var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-container"},_vm._l((_vm.task.data.response_option_count),function(values,index){return _c('task-chart-rating-item',{key:index,attrs:{"name":index,"values":values}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }